<cx-split-view [hideMode]="false">
  @if (structure$ | async; as structure) {
    @if (listData$ | async; as data) {
      <cx-view class="list">
        <div class="header">
          <div class="title">
            <h3>
              {{
              viewType + ".header" | cxTranslate: { count: getListCount(data) }
              }}
              <button
                type="button"
                tabindex="0"
                [cxPopover]="listHint"
              [cxPopoverOptions]="{
                placement: 'top',
                class: 'hint-popover',
                displayCloseButton: true
              }"
                >
                <cx-icon [type]="iconTypes.INFO"> </cx-icon>
              </button>
            </h3>
            <div class="horizontal-line-devider "></div>
          </div>
          <div class="actions">
            @if (data.pagination?.sort && data.sorts?.length > 0) {
              <label>
                <span>{{
                  structure.type + ".sortBy" | cxTranslate
                }}</span>
                @if (data.pagination?.sort) {
                  <ng-select
                    name="sort"
                    class="sort"
                    [searchable]="false"
                    [clearable]="false"
                    (change)="sort(data.pagination)"
                    [tabIndex]="0"
                    [(ngModel)]="sortCode"
              [attr.aria-label]="
                (sortCode
                  ? structure.type + '.sort.' + sortCode
                  : structure.type + '.sortBy'
                ) | cxTranslate
              "
                    >
                    @for (sort of data.sorts; track sort) {
                      <ng-option [value]="sort.code">
                        {{ structure.type + ".sort." + sort.code | cxTranslate }}
                      </ng-option>
                    }
                  </ng-select>
                }
              </label>
            }
            <ng-content select="[actions]"></ng-content>
            <a
              class="button primary create add-user-btn"
              [routerLink]="{ cxRoute: structure.type + 'Create' } | cxUrl"
              routerLinkActive="disabled"
              >
              <cx-icon [type]="customIconTypes.PLUS"></cx-icon>
              {{ "organization.add" | cxTranslate }}
            </a>
          </div>
        </div>
        @if (data.values?.length > 0) {
          <cx-table
            [structure]="structure"
            [data]="data.values"
            [i18nRoot]="domainType"
            [currentItem]="{ property: key, value: currentKey$ | async }"
            (launch)="launchItem($event)"
            [cxFocus]="{ trap: 'both' }"
            >
          </cx-table>
        } @else {
          <p class="instruction is-empty">
            {{ "organization.messages.emptyList" | cxTranslate }}
          </p>
        }
        <div class="footer">
          <cx-pagination
            [pagination]="data.pagination"
            (viewPageEvent)="browse(data.pagination, $event)"
          ></cx-pagination>
        </div>
      </cx-view>
    }
    <!-- nested split views are rendered inside child routes -->
    <router-outlet></router-outlet>
  }
</cx-split-view>


<ng-template #listHint>
  <p>
    {{ viewType + ".hint" | cxTranslate }}
  </p>
</ng-template>
